module.exports = __webpack_public_path__ + "static/media/medium-van.3204b838.svg";